// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CVU1","colMin":"styles_colMin__2No4-"};